import React from "react";
import { useController } from "react-hook-form";
import { DateFieldComponent } from "../../DatePicker";
import OpsDateUtils from "../../../utils/OpsDateUtils";

const START_DATE_FIELD = "shortStartDate";
const END_DATE_FIELD = "shortEndDate";

interface Props {
  control: any;
  register: any;
  errors: any;
  onStartDateChange: (date?: number) => void;
  onEndDateChange: (date?: number) => void;
}

function AssignationEditionFields({ control, register, errors, onStartDateChange, onEndDateChange }: Props) {
  // Registered here with the same defaults the pickers use, so both dates are readable on the first render
  const { field: shortStartDate } = useController({ control, name: START_DATE_FIELD, defaultValue: new Date() });
  const { field: shortEndDate } = useController({ control, name: END_DATE_FIELD, defaultValue: null });

  // The pickers work in the makeLocalAppearUTC space, so both bounds must be read in that same space
  const startDate = shortStartDate.value ? OpsDateUtils.makeLocalAppearUTC(shortStartDate.value) : undefined;

  const handleStartDateChange = (date?: number) => {
    onStartDateChange(date);
    const endDate = shortEndDate.value ? OpsDateUtils.makeLocalAppearUTC(shortEndDate.value) : null;
    if (endDate && date !== undefined && endDate.valueOf() < date) {
      shortEndDate.onChange(null);
      onEndDateChange(undefined);
    }
  };

  return (
    <>
      <DateFieldComponent
        control={control}
        register={register}
        errors={errors}
        propertyName={START_DATE_FIELD}
        label="Start Date"
        required={true}
        clearable={false}
        onChange={handleStartDateChange}
        toUTC
      />

      <DateFieldComponent
        control={control}
        register={register}
        errors={errors}
        propertyName={END_DATE_FIELD}
        label="End Date"
        required={false}
        clearable={true}
        minDate={startDate ?? undefined}
        onChange={onEndDateChange}
        toUTC
      />
    </>
  );
}

export default AssignationEditionFields;
